import React, { lazy } from "react"
import store from "./store"
import { Router, Switch, Route, Redirect } from "react-router-dom"
import { setNotFound, setLogout } from "actions"
import { checkLogoutNonce } from "utils/router.js"

import DefaultTemplate from "templates/DefaultTemplate"

// MainのJSファイルに含めるファイル
import Top from "pages/Top"
import Callback from "pages/Callback"
import history from "govHistory"
import { getTopPagePath } from "locale"

// jsファイルの分割を実施するファイル
const NoticeConfig = lazy(() => import("pages/NoticeConfig"))
const ThirdParty = lazy(() => import("pages/ThirdParty"))
const OneTouch = lazy(() => import("pages/OneTouch"))
const SeparateSetting = lazy(() => import("pages/SeparateSetting"))
const DisplayAgreement = lazy(() => import("pages/DisplayAgreement"))
const Information = lazy(() => import("pages/Information"))
const Location = lazy(() => import("pages/Location"))

const NoticeAgreementsSetting = lazy(
  () => import("pages/NoticeAgreementsSetting")
)

const GovRouter = () => {
  return (
    <Router history={history}>
      <DefaultTemplate>
        <Switch>
          <Route path="/" exact={true} component={Top} />
          <Route path="/noticeConfig" exact={true} component={NoticeConfig} />
          <Route path="/thirdParty" exact={true} component={ThirdParty} />
          <Route path="/oneTouch" exact={true} component={OneTouch} />
          <Route path="/information" exact={true} component={Information} />
          <Route path="/location" exact={true} component={Location} />
          <Route
            path="/separateSetting"
            exact={true}
            component={SeparateSetting}
          />

          <Route
            path="/displayAgreement"
            exact={true}
            component={DisplayAgreement}
          />

          <Route
            path="/noticeAgreementsSetting"
            exact={true}
            component={NoticeAgreementsSetting}
          />
          <Route path="/callback" exact={true} component={Callback} />
          <Route
            path="/logout"
            render={() => {
              if (checkLogoutNonce()) {
                store.dispatch(setLogout())
              } else {
                store.dispatch(setNotFound())
              }
              return <Redirect to={getTopPagePath()} />
            }}
          />

          <Route
            render={() => {
              store.dispatch(setNotFound())
              return <Redirect to={getTopPagePath()} />
            }}
          />
        </Switch>
      </DefaultTemplate>
    </Router>
  )
}

export default GovRouter
